export default __webpack_public_path__ + "assets/3f10931d88eb0f6dd732f8fa597d907e/05.jpg";